import { patterns } from "./formatPhoneNumber";

const prefixes = {
  355: "al",
  1: "us",
  383: "xk",
};

export const fieldsJSON = ({
  editingItem,
  employeeOptions,
  departmentOptions,
  employeeRoleOptions,
  employeeTeamOptions,
}) => [
  {
    name: "contactId",
    style: { display: "none" },
  },
  {
    type: "select",
    required: true,
    showSearch: true,
    name: "fullName",
    label: "Punonjësi",
    disabled: !!editingItem,
    customOptions: employeeOptions,
    filterOption: (input, option) =>
      option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0,
  },
  {
    type: "select",
    required: true,
    showSearch: true,
    name: "department",
    label: "Departamenti",
    disabled: !!editingItem,
    options: departmentOptions,
    placeholder: "Zgjidh departamentin",
  },
  {
    type: "select",
    required: true,
    showSearch: true,
    label: "Pozicioni",
    disabled: !!editingItem,
    name: "employeeRoleName",
    placeholder: "Zgjidh pozicionin",
    options: employeeRoleOptions,
  },
  {
    label: "Dega",
    type: "select",
    required: true,
    showSearch: true,
    name: "employeeTeam",
    disabled: !!editingItem,
    options: employeeTeamOptions,
  },
  {
    name: "employeePhoneNumber",
    type: "phone",
    required: true,
    country: getCountry(editingItem),
    label: "Numri i Telefonit",
  },
  {
    name: "employeeEmail",
    type: "input",
    label: "Email",
    rules: [
      { type: "email", message: "Ju lutem shkruani një email të vlefshëm" },
    ],
    required: true,
  },
  {
    label: "Detaje",
    type: "textarea",
    name: "employeeDetails",
  },
  {
    name: "googleDriveFileId",
    style: { display: "none" },
  },
];

const getCountry = (editingItem) => {
  if (!editingItem) return "al";
  const rawNumber = (editingItem.employeePhoneNumber || "").replace(/\D/g, "");
  const prefix = Object.keys(patterns).find((pref) =>
    rawNumber.startsWith(pref)
  );
  return prefixes[prefix] || "al";
};
